export default __webpack_public_path__ + "static/media/smedetoften-tenancy-01.95b07f7c.jpg";